import { CruiseDay, ItineraryResponse } from '@msc-b2c/interfaces/types';
import { replacePlaceholders } from '@msc-b2c/shared-utils';

export function buildTextFromItinerary(
  itineraryData: ItineraryResponse | null | undefined,
  day: string | undefined,
  portCode: string | undefined,
  startDate: string | undefined,
  dayAtSeaLabelValue: string | undefined,
  text: string
) {
  let portName: string | undefined = '';
  if (itineraryData && day && portCode && startDate) {
    itineraryData.days.forEach((day: CruiseDay) => {
      if (day.date === startDate && day.port.code === portCode) {
        portName = day.port.name;
      } else if (portCode === 'ATC') {
        portName = dayAtSeaLabelValue;
      }
    });
    text = text.includes('{dayNumber}') ? replacePlaceholders(text, { dayNumber: day }) : text;
    text = text.includes('{portName}') ? replacePlaceholders(text, { portName: portName }) : text;
  }
  return text;
}
